import { useProvideHeadlessUiId } from '@autobid/ui/composables/useProvideHeadlessUiId'
import { TITLE } from '../constants/TITLE'

export function useAppProvides() {
  useProvideHeadlessUiId()
  provide('pageTitle', TITLE)
}
